/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRolesSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListRolesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListRolesSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListRolesSecurity$outboundSchema: z.ZodMiniType<
  ListRolesSecurity$Outbound,
  ListRolesSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listRolesSecurityToJSON(
  listRolesSecurity: ListRolesSecurity,
): string {
  return JSON.stringify(
    ListRolesSecurity$outboundSchema.parse(listRolesSecurity),
  );
}

/** @internal */
export type ListRolesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListRolesRequest$outboundSchema: z.ZodMiniType<
  ListRolesRequest$Outbound,
  ListRolesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listRolesRequestToJSON(
  listRolesRequest: ListRolesRequest,
): string {
  return JSON.stringify(
    ListRolesRequest$outboundSchema.parse(listRolesRequest),
  );
}
